/* Maison Duclain : cale les sous-menus du header pile sous la barre, quelle que soit sa hauteur */
(function () {
  function place(details) {
    var wrapper = details.closest('.header__wrapper');
    var summary = details.querySelector(':scope > summary');
    if (!wrapper || !summary) return;
    var offset = wrapper.getBoundingClientRect().bottom - summary.getBoundingClientRect().bottom;
    details.style.setProperty('--dd-offset', Math.max(0, Math.round(offset)) + 'px');
  }
  function bind() {
    document.querySelectorAll('.header__link-list details').forEach(function (details) {
      if (details.dataset.ddBound) return;
      details.dataset.ddBound = '1';
      ['mouseenter', 'focusin', 'click'].forEach(function (evt) {
        details.addEventListener(evt, function () { place(details); });
      });
      place(details);
    });
  }
  function placeAll() {
    document.querySelectorAll('.header__link-list details').forEach(place);
  }
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('resize', placeAll);
  window.addEventListener('scroll', placeAll, { passive: true });
  if (document.readyState !== 'loading') bind();
})();

/* Maison Duclain : animations d'ouverture et de fermeture des sous-menus du header (rideau qui descend puis remonte) */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('dropdown-disclosure').then(function () {
    var C = customElements.get('dropdown-disclosure');
    if (!C || C.prototype.__duclainPatched) return;
    C.prototype.__duclainPatched = true;
    var originalIn = C.prototype._transitionIn;
    var originalOut = C.prototype._transitionOut;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var OPEN = 'inset(0 -18px -70px -18px)';
    /* Le menu se ferme 0,25 s après la sortie du curseur : on peut passer d'un élément à l'autre sans qu'il se ferme */
    var toleranceDesc = Object.getOwnPropertyDescriptor(C.prototype, 'mouseOverDelayTolerance');
    Object.defineProperty(C.prototype, 'mouseOverDelayTolerance', {
      configurable: true,
      get: function () {
        if (this.closest('.header__link-list')) return 250;
        return toleranceDesc && toleranceDesc.get ? toleranceDesc.get.call(this) : 250;
      }
    });
    function otherOpen(details) {
      var list = details.closest('.header__link-list');
      return !!(list && Array.prototype.some.call(list.querySelectorAll('details[open]'), function (d) { return d !== details; }));
    }
    var CLOSED = 'inset(0 -18px 100% -18px)';

    C.prototype._transitionIn = function () {
      if (!this.closest('.header__link-list')) return originalIn.apply(this, arguments);
      var el = this.contentElement;
      el.getAnimations().forEach(function (a) { a.cancel(); });
      var fromSibling = arguments[0] === true;
      var panel = el.animate(
        [{ opacity: fromSibling ? 0 : 1, clipPath: fromSibling ? OPEN : CLOSED }, { opacity: 1, clipPath: OPEN }],
        { duration: reduce ? 0 : (fromSibling ? 380 : 1100), delay: reduce ? 0 : (fromSibling ? 90 : 0), easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' }
      );
      el.querySelectorAll(':scope > ul > li').forEach(function (li, i) {
        li.animate(
          [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }],
          { duration: reduce ? 0 : 500, delay: reduce ? 0 : 220 + i * 90, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' }
        );
      });
      return panel.finished.catch(function () {});
    };

    C.prototype._transitionOut = function () {
      if (!this.closest('.header__link-list')) return originalOut.apply(this, arguments);
      var el = this.contentElement;
      el.getAnimations().forEach(function (a) { a.cancel(); });
      var switching = otherOpen(this);
      var panel = el.animate(
        switching ? [{ opacity: 1, clipPath: OPEN }, { opacity: 0, clipPath: OPEN }] : [{ opacity: 1, clipPath: OPEN }, { opacity: 1, clipPath: CLOSED }],
        { duration: reduce ? 0 : (switching ? 140 : 250), easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards' }
      );
      /* Si le menu est rouvert pendant la fermeture, l'animation est annulée : on laisse le menu ouvert */
      return panel.finished.catch(function () { return new Promise(function () {}); });
    };
  });
})();
